import React, { useEffect, useState, useContext } from 'react';
import { UserContext } from '../userContext/UserContext';
import './contextmenu.css';

const ContextMenu = ({ x, y, onUpdate, onDelete }) => {
    const { role } = useContext(UserContext);

    const [position, setPosition] = useState({ top: y, left: x });

    useEffect(() => {
        const menuWidth = 150; // Same as your CSS width
        const menuHeight = 80;  // Adjust based on button size

        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;

        let newX = x;
        let newY = y;

        // Adjust position if the menu overflows right
        if (x + menuWidth > windowWidth) {
            newX = windowWidth - menuWidth - 10; // Add margin
        }

        // Adjust position if the menu overflows bottom
        if (y + menuHeight > windowHeight) {
            newY = windowHeight - menuHeight - 10; // Add margin
        }

        setPosition({ top: newY, left: newX });
    }, [x, y]);

    return (
        <div className="context-menu" style={{ top: `${position.top}px`, left: `${position.left}px` }}>
            <button onClick={onUpdate}>Update</button>
            {role === 'Role.Admin' && <button onClick={onDelete}>Delete</button>}
        </div>
    );
};

export default ContextMenu;
